import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/api/client";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const u = await loginWithGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        const hasWs = !!localStorage.getItem("avida_workspace");
        if (u?.role === "field_agent") nav("/field", { replace: true });
        else if (!hasWs) nav("/choose", { replace: true });
        else nav(u?.role === "staff" ? "/my-day" : "/", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        toast.error(formatApiError(e), { duration: 10000 });
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-screen grid place-items-center bg-[#FAFBFC]">
      <div className="flex flex-col items-center gap-3">
        <img src="/brand/avida-logo.png" alt="Avida" className="h-12 w-auto" />
        <div className="text-sm font-semibold text-[#15233B]/60">Signing you in…</div>
      </div>
    </div>
  );
}
